/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'
import type { ObjectMap } from '@react-three/fiber'
import { Select } from '@react-three/postprocessing'
import { type JSX } from 'react'
import type { Mesh, MeshStandardMaterial } from 'three'
import type { GLTF } from 'three-stdlib'

import { toLambert } from '@utils'

type GLTFResult = GLTF &
  ObjectMap & {
    nodes: {
      Sign9_1: Mesh
      Sign9_2: Mesh
      Sign9_3: Mesh
      Sign9_4: Mesh
    }
    materials: {
      ['Dark Wood']: MeshStandardMaterial
      ['Light Wood']: MeshStandardMaterial
      Rocks: MeshStandardMaterial
      Herbs: MeshStandardMaterial
    }
  }

type WoodenSignSmallModelProps = JSX.IntrinsicElements['group'] & {
  highlight?: boolean
  secondary?: boolean
}

export function WoodenSignSmallModel({
  highlight,
  secondary,
  onClick,
  onPointerOver,
  onPointerOut,
  onPointerEnter,
  onPointerLeave,
  ...props
}: WoodenSignSmallModelProps) {
  const { nodes, materials } = useGLTF('/models/wooden-sign-small.glb') as GLTFResult

  return (
    <group {...props}>
      <group scale={100}>
        <mesh
          visible={!secondary}
          castShadow
          receiveShadow
          geometry={nodes.Sign9_1.geometry}
          material={toLambert(materials['Dark Wood'])}
        />
        <Select enabled={highlight}>
          <mesh
            scale-y={0.8}
            position-y={0.0035}
            castShadow
            receiveShadow
            geometry={nodes.Sign9_2.geometry}
            material={toLambert(materials['Light Wood'])}
            onClick={onClick}
            onPointerOver={onPointerOver}
            onPointerOut={onPointerOut}
            onPointerEnter={onPointerEnter}
            onPointerLeave={onPointerLeave}
          />
        </Select>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Sign9_3.geometry}
          material={toLambert(materials.Rocks)}
        />
        <mesh
          visible={!secondary}
          castShadow
          receiveShadow
          geometry={nodes.Sign9_4.geometry}
          material={toLambert(materials.Herbs)}
        />
      </group>
    </group>
  )
}

useGLTF.preload('/models/wooden-sign-small.glb')
